export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS'
export const FETCH_QUIZ_FAILURE = 'FETCH_QUIZ_FAILURE'
export const LEAVE_QUIZ = 'LEAVE_QUIZ'
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS'
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE'
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

export const FETCH_REGIMEN_ELEMENTS_SUCCESS = 'FETCH_REGIMEN_ELEMENTS_SUCCESS'
export const FETCH_REGIMEN_ELEMENTS_FAILURE = 'FETCH_REGIMEN_ELEMENTS_FAILURE'
export const FETCH_ALL_REGIMEN_ELEMENTS_SUCCESS = 'FETCH_ALL_REGIMEN_ELEMENTS_SUCCESS'
export const FETCH_ALL_REGIMEN_ELEMENTS_FAILURE = 'FETCH_ALL_REGIMEN_ELEMENTS_FAILURE'
export const FETCH_USER_REGIMEN_ELEMENTS_SUCCESS = 'FETCH_USER_REGIMEN_ELEMENTS_SUCCESS'
export const FETCH_USER_REGIMEN_ELEMENTS_FAILURE = 'FETCH_USER_REGIMEN_ELEMENTS_FAILURE'
export const FETCH_NOTES_SUCCESS = 'FETCH_NOTES_SUCCESS'
export const FETCH_NOTES_FAILURE = 'FETCH_NOTES_FAILURE'
export const FETCH_INSIGHTS_SUCCESS = 'FETCH_INSIGHTS_SUCCESS'
export const FETCH_INSIGHTS_FAILURE = 'FETCH_INSIGHTS_FAILURE'

export const FETCH_SHOP_PRODUCTS_SUCCESS = 'FETCH_SHOP_PRODUCTS_SUCCESS'
export const FETCH_SHOP_PRODUCTS_FAILURE = 'FETCH_SHOP_PRODUCTS_FAILURE'
export const FETCH_BLOG_SUCCESS = 'FETCH_BLOG_SUCCESS'
export const FETCH_BLOG_FAILURE = 'FETCH_BLOG_FAILURE'
export const FETCH_PRODUCTS_LOG_SUCCESS = 'FETCH_PRODUCTS_LOG_SUCCESS'
export const FETCH_PRODUCTS_LOG_FAILURE = 'FETCH_PRODUCTS_LOG_FAILURE'
export const CART_UPDATE = 'CART_UPDATE'

export const FETCH_PLANS_SUCCESS = 'FETCH_PLANS_SUCCESS'
export const FETCH_PLANS_FAILURE = 'FETCH_PLANS_FAILURE'

export const FETCH_STRIPE_SUCCESS = 'FETCH_STRIPE_SUCCESS'
export const FETCH_STRIPE_FAILURE = 'FETCH_STRIPE_FAILURE'
export const FETCH_PAYMENT_METHODS_SUCCESS = 'FETCH_PAYMENT_METHODS_SUCCESS'
export const FETCH_PAYMENT_METHODS_FAILURE = 'FETCH_PAYMENT_METHODS_FAILURE'
export const FETCH_INTENT_TOKEN_SUCCESS = 'FETCH_INTENT_TOKEN_SUCCESS'
export const FETCH_INTENT_TOKEN_FAILURE = 'FETCH_INTENT_TOKEN_FAILURE'
export const FETCH_PLAN_ID_SUCCESS = 'FETCH_PLAN_ID_SUCCESS'
export const FETCH_PLAN_ID_FAILURE = 'FETCH_PLAN_ID_FAILURE'

export const FETCH_ADMIN_DATA_SUCCESS = 'FETCH_ADMIN_DATA_SUCCESS'
export const FETCH_ADMIN_DATA_FAILURE = 'FETCH_ADMIN_DATA_FAILURE'

export const FETCH_REGIMEN_DATA_SUCCESS = 'FETCH_REGIMEN_DATA_SUCCESS'
export const FETCH_REGIMEN_DATA_FAILURE = 'FETCH_REGIMEN_DATA_FAILURE'

export const FETCH_DELETE_USER_SUCCESS = 'FETCH_DELETE_USER_SUCCESS'
export const FETCH_DELETE_USER_FAILURE = 'FETCH_DELETE_USER_FAILURE'

export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const EDIT_USER_FAILURE = 'EDIT_USER_FAILURE'

export const ADD_USER_FAILURE = 'ADD_USER_FAILURE'
export const SET_EDITED_USER_ID = 'SET_EDITED_USER_ID'

export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE'

export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS'

export const FETCH_ALL_NOTES_SUCCESS = 'FETCH_ALL_NOTES_SUCCESS'
export const FETCH_ALL_INSIGHT_SUCCESS = 'FETCH_ALL_INSIGHT_SUCCESS'

export const FETCH_CURL_STATUS_SUCCESS = 'FETCH_CURL_STATUS_SUCCESS'
export const FETCH_CURL_STATUS_FAILURE = 'FETCH_CURL_STATUS_FAILURE'

export const FETCH_USER_WEEK = 'FETCH_USER_WEEK'
export const FETCH_USER_WEEK_FAILURE = 'FETCH_USER_WEEK_FAILURE'
export const FETCH_USER_CALENDAR = 'FETCH_USER_CALENDAR'
export const FETCH_USER_CALENDAR_FAILURE = 'FETCH_USER_CALENDAR_FAILURE'
export const FETCH_USER_CALENDAR_ELEMENT = 'FETCH_USER_CALENDAR_ELEMENT'

export const FETCH_DELETE_REGIMEN_SUCCESS = 'FETCH_DELETE_REGIMEN_SUCCESS'
export const FETCH_DELETE_REGIMEN_FAILURE = 'FETCH_DELETE_REGIMEN_FAILURE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js